import { API_URL } from 'src/config/environment'
import apiCreator from '../api-creator'

interface Params {
  itemIds: Array<string>
}

export function cancelRegisterItems(data: Params): Promise<void> {
  return apiCreator
    .post(
      `${API_URL.TWIN}/cancel-register`,
      {
        ids: data.itemIds,
      },
    )
}
